import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
// import * as _ from 'lodash';
import slug from 'constants/slug';
import { getOne, getInspectionDetail } from 'api/inspectionApi';
import styled from 'styled-components';
import Clearfix from 'components/elements/clearfix';
import DisplayField from 'components/elements/display-field';
// import InnerHTML from 'components/elements/InnerHTML';
import { Icon, Intent } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { Link } from 'react-router-dom';
import moment from 'moment';
import AttachmentContainer from 'containers/AttachmentContainer';
import * as _ from 'lodash'
import {
  getList as getAttachList,
  deleteOne as deleteAttach,
  create as createAttach,
} from 'api/inspectionAttachmentApi';
import { deleteOne } from 'api/inspectionApi';
import Message from 'rc-message';
import { getLookupTypeInspectionAttachment } from 'api/lookuplistitemApi';
import Confirm from 'components/elements/confirm-element';
// import { Row, Col } from 'reactstrap';
import PageLockHOC from 'hoc/pageLock';
import Permissions from 'react-redux-permissions';
import { DATE_FORMAT, DATETIME_FORMAT } from 'config';
import { COLOR } from 'config';

const ContainerWrapper = styled.div``;
const ContainerHeader = styled.div`
  display: flex;
`;
const ContainerAction = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
const Content = styled.div``;

const NameContainer = styled.div`
  color: ${COLOR.SECOND_COLOR};
  text-decoration: underline;
`;

@PageLockHOC(['facilityInspection.view'])
export default class InspectionView extends React.Component {
  static propTypes = {};

  state = {
    _idObject: '',
    isLoading: true,
    initialValue: {},
    initialDetail: [],
  };

  columnDetails = [
    {
      dataField: 'Facility',
      text: 'Tên cơ sở/dự án',
      formatter: (cell, row) => {
        return (
          <Link
            to={`${slug.INSPECTTION.VIEW_WITH_ID_CHILD}${row._id
              }/${this.getId()}`}
          >
            <NameContainer>{cell && cell.FacilityNameFull}</NameContainer>
          </Link>
        );
      },
    },
    {
      dataField: 'status.Name',
      text: 'Trạng thái cập nhật',
    },
    {
      dataField: 'AddedOn',
      text: 'Thêm vào',
      formatter: (cell, row) => {
        return <div>{cell ? moment(cell).format(DATE_FORMAT) : ''}</div>;
      },
    },
    {
      dataField: 'UpdatedOn',
      text: 'Cập nhật ngày',
      formatter: (cell, row) => {
        if (!cell) {
          return null;
        }
        return <div>{cell ? moment(cell).format(DATE_FORMAT) : ''}</div>;
      },
    },
  ];

  getId() {
    const _id = _.get(this.props, 'match.params._id');
    return _id;
  }

  async checkValidate() {
    const _id = this.getId();
    if (_id) {
      const res = await getOne(_id);
      if (res.success) {
        this.setState({
          _idObject: _id,
          isLoading: false,
          initialValue: res.data,
        });
      }
    } else {
      this.props.history.push(slug.INSPECTTION.LIST);
    }
  }

  async getInspectionDetail() {
    const _id = this.getId();
    if (_id) {
      const res = await getInspectionDetail(_id);
      if (res.success) {
        this.setState({
          initialDetail: _.get(res, 'data', []),
        });
      }
    } else {
      this.props.history.push(slug.INSPECTTION.LIST);
    }
  }

  updateInitialValue = (values) => {
    this.setState({
      _idObject: values._id,
      isLoading: false,
      initialValue: values,
    });
  };

  componentWillMount = async () => {
    await Promise.all([this.checkValidate(), this.getInspectionDetail()]);
  };

  getInitialValue = (keyPath, defaultValue = '', type = 'string') => {
    const value = _.result(this.state.initialValue, keyPath, defaultValue);
    if (!value || value === '') {
      return '';
    }
    switch (type) {
      case 'date':
      case 'date_1':
        return moment(value).format(
          type === 'date_1' ? DATETIME_FORMAT : DATE_FORMAT
        );
      case 'dates':
        return `${moment(value[0]).format('DD/MM/YYYY')} - ${moment(
          value[1]
        ).format('DD/MM/YYYY')}`;
      default:
        return value;
    }
  };

  handelDelete = () => {
    if (this.ConfirmElm && this.ConfirmElm.showConfirm) {
      const InspectionNumber = this.getInitialValue('InspectionNumber');
      this.ConfirmElm.showConfirm({
        content: (
          <div>
            {' '}
            {`Bạn có muốn xoá số quyết định đoàn thanh tra: `}{' '}
            <b>{InspectionNumber}</b>
          </div>
        ),
        cb: async (value) => {
          if (value) {
            const res = await deleteOne(this.getInitialValue('_id'));
            if (res.success) {
              Message.success({ content: 'Thành Công' });
              this.props.history.push(slug.INSPECTTION.LIST);
            }
            if (res.error) Message.error({ content: res.message });
          }
        },
      });
    }
  };

  render() {
    return (
      <ContainerWrapper>
        <Confirm ref={(ConfirmElm) => (this.ConfirmElm = ConfirmElm)} />
        {!this.state.isLoading && (
          <div>
            <ContainerHeader>
              <h3
                style={{
                  color: COLOR.SECOND_COLOR,
                }}
                className='bp3-heading'
              >
                Chi tiết thanh tra
              </h3>
            </ContainerHeader>
            <ContainerAction>
              <div style={{ display: 'inline-flex' }}>
                <Icon
                  onClick={() => {
                    this.props.history.push(slug.INSPECTTION.LIST);
                  }}
                  style={{ cursor: 'pointer', color: COLOR.SUCCESS }}
                  icon={IconNames.CIRCLE_ARROW_LEFT}
                  iconSize={Icon.SIZE_LARGE}
                  intent={Intent.SUCCESS}
                />

                <Permissions allowed={[`facilityInspection.write`]}>
                  <React.Fragment>
                    <Clearfix width={8} />
                    <Link
                      to={
                        slug.INSPECTTION.EDIT_WITH_ID +
                        this.getInitialValue('_id')
                      }
                    >
                      <Icon
                        style={{ cursor: 'pointer', color: COLOR.SUCCESS }}
                        icon={IconNames.MANUALLY_ENTERED_DATA}
                        iconSize={Icon.SIZE_LARGE}
                        intent={Intent.PRIMARY}
                      />
                    </Link>
                  </React.Fragment>
                </Permissions>

                <Permissions allowed={[`facilityInspection.delete`]}>
                  <React.Fragment>
                    <Clearfix width={8} />
                    <Icon
                      style={{ cursor: 'pointer' }}
                      icon={IconNames.BAN_CIRCLE}
                      iconSize={Icon.SIZE_LARGE}
                      intent={Intent.DANGER}
                      onClick={this.handelDelete}
                    />
                  </React.Fragment>
                </Permissions>
              </div>
            </ContainerAction>
            <Clearfix height={12} />
            <Content>
              <Clearfix height={12} />
              <DisplayField
                size={14}
                isRequiredField={true}
                label='Số quyết định đoàn thanh tra'
                value={this.getInitialValue('InspectionNumber')}
              />
              <Clearfix height={12} />
              <DisplayField
                size={14}
                isRequiredField={true}
                label='Thời gian thanh tra'
                value={this.getInitialValue('InspectionDate', '', 'dates')}
              />
              <Clearfix height={12} />
              <DisplayField
                size={14}
                label='Ngày ra quyết định'
                value={this.getInitialValue('DecideDate', '', 'date')}
              />
              <Clearfix height={12} />
              <DisplayField
                size={14}
                label='Cơ quan ban hành'
                value={this.getInitialValue('AgencyIssued')}
              />
              <Clearfix height={12} />
              <DisplayField
                size={14}
                label='Ghi chú kế hoạch thanh tra'
                value={this.getInitialValue('Notes')}
              />
              <Clearfix height={16} />
              <DisplayField
                label='Thêm vào'
                value={
                  this.getInitialValue('AddedOn', '', 'date_1') +
                  ' bởi ' +
                  this.getInitialValue('AddedBy')
                }
              />
              <Clearfix height={16} />
              <DisplayField
                label='Cập nhật lần cuối'
                value={`${this.getInitialValue('UpdatedOn', '', 'date_1')}${this.getInitialValue('UpdatedBy', '')
                  ? ` bởi ${this.getInitialValue('UpdatedBy', '')}`
                  : ''
                  }`}
              />
              <Clearfix height={32} />
              <div>
                <BootstrapTable
                  keyField='_id'
                  data={_.sortBy(this.state.initialDetail, ['Facility.FacilityNameFull'])}
                  columns={this.columnDetails}
                  striped
                  hover
                  remote
                />
              </div>
              <Clearfix height={32} />
              <AttachmentContainer
                // hideButtonAction={this.state.isEdit ? false : true}
                facility={this.state.initialValue}
                getListFunc={(query) => {
                  return getAttachList({
                    ...query,
                    inspection: this.getInitialValue('_id'), //_id của inspection
                  });
                }}
                createOne={(values) => {
                  values.inspection = this.getInitialValue('_id');
                  return createAttach(_.pickBy(values, _.identity));
                }}
                deleteOne={deleteAttach}
                getAttachmentTypeList={getLookupTypeInspectionAttachment}
                moduleName='facilityInspection'
              />
            </Content>
          </div>
        )}
      </ContainerWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Inspection/InspectionView/index.js